<template>
  <a-button-group class="mr-2">
    <a-tooltip :title="t('propsEditor.alignLeft')">
      <a-button @click="$emit('component-event', { name: 'align-clicked', value: 'left' })">
        <img src="@/assets/icons/align-left.svg" width="20" alt="" />
      </a-button>
    </a-tooltip>
    <a-tooltip :title="t('propsEditor.alignCenterH')">
      <a-button @click="$emit('component-event', { name: 'align-clicked', value: 'centerH' })">
        <img src="@/assets/icons/align-h-center.svg" width="20" alt="" />
      </a-button>
    </a-tooltip>
    <a-tooltip :title="t('propsEditor.alignRight')">
      <a-button @click="$emit('component-event', { name: 'align-clicked', value: 'right' })">
        <img src="@/assets/icons/align-right.svg" width="20" alt="" />
      </a-button>
    </a-tooltip>
    <a-tooltip :title="t('propsEditor.alignTop')">
      <a-button @click="$emit('component-event', { name: 'align-clicked', value: 'top' })" class="!ml-2">
        <img src="@/assets/icons/align-top.svg" width="20" alt="" />
      </a-button>
    </a-tooltip>
    <a-tooltip :title="t('propsEditor.alignCenterV')">
      <a-button @click="$emit('component-event', { name: 'align-clicked', value: 'centerV' })">
        <img src="@/assets/icons/align-v-center.svg" width="20" alt="" />
      </a-button>
    </a-tooltip>
    <a-tooltip :title="t('propsEditor.alignBottom')">
      <a-button @click="$emit('component-event', { name: 'align-clicked', value: 'bottom' })">
        <img src="@/assets/icons/align-bottom.svg" width="20" alt="" />
      </a-button>
    </a-tooltip>
  </a-button-group>
</template>
<script>
import { ref, watch } from 'vue';
import { props } from './helper';

import { AlignLeftOutlined, AlignCenterOutlined, AlignRightOutlined } from '@ant-design/icons-vue';
import i18n from '@/locales/i18n';

const { t } = i18n.global;
export default {
  components: { AlignLeftOutlined, AlignCenterOutlined, AlignRightOutlined },
  props,
  emits: ['component-event'],
  setup(props) {
    return {
      t,
    };
  },
};
</script>
<style lang="less" scoped>
.ant-btn {
  padding: 0 9px;
}
</style>
